import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      columnGap: '20px',
      alignItems: 'top',
    },
    picture: {
      '& img': {
        borderRadius: '4px',
        width: '120px',
        height: '120px',
        padding: '4px',
        border: '1px solid #ddd',
        transition: 'all .2s ease-in-out',
      },
    },
    summary: {
      fontSize: '14px',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '5px',
    },
    name: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
    dropdownButton: {
      textTransform: 'none',
      justifyContent: 'space-between',
      width: '100%',
    },
    dropdownList: {
      width: '260px',
      margin: 0,
      padding: 0,
    },
    dropdownLoading: {
      justifyContent: 'center',
    },
    dropdownItem: {
      padding: 0,
    },
    dropdownLink: {
      display: 'block',
      width: '100%',
      padding: '6px 16px',
      fontSize: '14px',
      textDecoration: 'none',
      '& .text': {
        display: 'block',
        color: legacyColors.text.default,
      },
      '& .description': {
        color: '#aaa',
        display: 'block',
        overflow: 'hidden',
        fontWeight: 'normal',
        lineHeight: '1.4em',
      },
    },
  };
};
